import axios from 'axios';
import { processTemperatureData } from '../utils/temperatureDataProcessor';
import { baseURL } from '../utility/Constants';

class TempMetricsService {
    async fetchTemperatureData(emsName, timeFilter, date) {
        try {
            const response = await axios.post(`${baseURL}/temperature-metrics`, {
                emsName,
                timeFilter,
                date
            });

            return processTemperatureData(response.data);
        } catch (error) {
            console.error('Error fetching temperature data:', error);
            throw error;
        }
    }
}

export default new TempMetricsService();
